import Component from '../core/Component'
import salvattore from 'salvattore'

export const STATES = {
    READY: 'is-ready',
}

export default class Masonery extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            list: null,
            items: []
        }

        this.offset = 120
    }

    prepare() {
        salvattore.appendElements(this.ref.list, this.ref.items)
        this.element.classList.add(STATES.READY)
    }
}